import React from 'react';
import newswire from '../../../assets/images/newswire.jpg'
import mcpayment from '../../../assets/images/mcpayment.png'
import mcpayment_one from '../../../assets/images/mcpayment_one.png'
import mcpayment_two from '../../../assets/images/mcpayment_two.jpg'
import asx from '../../../assets/images/asx.jpg'
import asx_one from '../../../assets/images/asx_one.png'
import shopback from '../../../assets/images/shopback.jpg'
import boomwatch from '../../../assets/images/boomwatch.jpg'
import guavapass from '../../../assets/images/guavapass.jpg'
import artivision from '../../../assets/images/artivision.jpg'
import rakuten from '../../../assets/images/rakuten.jpg'

export default function news(){
  return(
    <div className="post-1361 page type-page status-publish has-post-thumbnail hentry">
      <div className="blog-single-post nosidebar">
        <section className="subpage-banner"></section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-12">
                  <h2 className="post-title">News</h2>
                  <div className="post-article">
                    <div id="dt_row_1" className="clearfix dt_row">
                      <div id="dt_column_2" className="dt_column col-sm-12">
                        <div id="dt_text3153734994394" className="dt_text">
                          <div className="otw-row">
                            <section className="otw-twentyfour otw-columns otw-bm-list-section" id="otw-bm-list-1">
                              <div className="otw_blog_manager-blog-timeline-heading"></div>
                              <div className="otw-row otw_blog_manager-blog-item-holder otw_blog_manager-blog-timeline with-heading bm_clearfix">
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
                                <h3 className="otw_blog_manager-timeline-title">April 2019</h3>
                                  <article className="otw_blog_manager-blog-full  ">
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={rakuten} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/singapore-rewards-app-shopBack-raises-45m-led-by-ev-growth-rakuten/" className="otw-link-single">Singapore’s rewards app ShopBack raises $45m led by EV Growth, Rakuten</a>
                                      </h3>
                                    </div>
                                
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                       (Read more at https://www.dealstreetasia.com/stories/singapore-startup-shopback-snags-45m-in-rakuten-led-round-129974/)
                                        <br />
                                        <br />
                                        April 10, 2019 ShopBack, a Singapore-based rewards discovery platform, has raised $45 million in a Series B funding led by EV Growth and Rakuten Capital. EDBI and other existing investors also participated in this round. A number of appointments have also been made to ShopBack’s board as a result of the capital raise. Amit Patel, CEO of Ebates, Inc., a Rakuten company, and Willson Cuaca, managing partner of EV Growth, will join ShopBack’s board of directors.
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                  <h3 className="otw_blog_manager-timeline-title">Aug 2018</h3>
                                  <article className="otw_blog_manager-blog-full  ">
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={newswire} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund/" className="otw-link-single">Global SaaS Commerce Platform TradeGecko Raises USD 10M in Series B Funding Led by TNB Aura Fund 1 &amp; Aura Venture Fund</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                       (Read more at https://www.techinasia.com/helicap-seed-funding)
                                        <br />
                                        <br />
                                        SINGAPORE &amp; TORONTO, July 24, 2018 /PRNewswire/ -- TradeGecko, the leading global SaaS inventory and order management platform for small-medium businesses (SMBs), today announced a Series B investment of USD 10M, led by TNB Aura Fund 1 and Aura Venture Fund, with Perle Ventures, and 33 Capital
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
                                  <h3 className="otw_blog_manager-timeline-title">May 2018</h3>
                                  <article className="otw_blog_manager-blog-full">
                                    
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/mc-payment-takes-long-view-on-going-cashless/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={mcpayment} alt="" title=""/>
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/mc-payment-takes-long-view-on-going-cashless/" className="otw-link-single">Startup bags funds from Singapore ex-minister to get ultra-wealthy into crowdlending</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        (Read more at https://www.techinasia.com/helicap-seed-funding)
                                        <br />
                                        <br />
                                        Singapore-based Helicap is a new fintech platform that aims to bring a fund management angle in the peer-to-peer (P2P) lending space. To make this happen, it has raised US$1.5 million in seed funding.
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/mc-payment-takes-long-view-on-going-cashless/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>  
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
                                  <article className="otw_blog_manager-blog-full">
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="otw-link-single">Helicap raises US$1.5M seed funding round led by Singapore's ex-minister of state Teo Ser Luck</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        Read more at https://e27.co/helicap-raises-us1-5m-seed-funding-round-led-by-ex-minister-20180502/
                                        <br />
                                        <br />
                                        Helicap offers a proprietary platform that raises capital and utilises big data to analyse potential investments for institutional investors, family offices, and high-networth individuals, allowing them to make “superior and consistent” investment returns via alternative channels such as microfinance institutions, small- and medium-sized enterprises (SMEs), and peer-to-peer
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
                                  <article className="otw_blog_manager-blog-full  ">
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="otw-link-single">Fintech startup Helicap raises $1.5m seed round led by former SG minister</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        Read More @ https://www.dealstreetasia.com/stories/helicap-singapore-97065/
                                        <br />
                                        <br />
                                        Fintech startup Helicap has announced the closing of a seed funding round of $1.5 million led by Singapore’s former Minister of State and the Chairman of Nufin Data, Teo Ser Luck.
                                        <br />
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
                                  <h3 className="otw_blog_manager-timeline-title">Dec 2017</h3>
                                  <article className="otw_blog_manager-blog-full  ">
                                    
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/singapores-coassets-is-first-crowdfunding-firm-to-list-in-australia-read-more-at-http-www-channelnewsasia-com-news-business-singapore-s-coassets-is-first-crowdfunding-firm-to-list-in-austr/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={asx_one} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/singapores-coassets-is-first-crowdfunding-firm-to-list-in-australia-read-more-at-http-www-channelnewsasia-com-news-business-singapore-s-coassets-is-first-crowdfunding-firm-to-list-in-austr/" className="otw-link-single">Singapore’s CoAssets is first crowdfunding firm to list in Australia</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        <br />
                                        <br />
                                        (Read more at http://www.channelnewsasia.com/news/business/singapore-s-coassets-is-first-crowdfunding-firm-to-list-in-austr-7802526)
                                        <br />
                                        <br />
                                        Previously listed on the National Stock Exchange of Australia (NSX), CoAssets started trading on the main Australian Securities Exchange (ASX) on Monday (Sep 5) after raising S$6.72 million in a public offering.
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        SINGAPORE: Homegrown crowdfunding platform CoAssets made its debut on the Australian Securities Exchange (ASX) on Monday
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/singapores-coassets-is-first-crowdfunding-firm-to-list-in-australia-read-more-at-http-www-channelnewsasia-com-news-business-singapore-s-coassets-is-first-crowdfunding-firm-to-list-in-austr/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
                                  <h3 className="otw_blog_manager-timeline-title">Nov 2017</h3>
                                  <article className="otw_blog_manager-blog-full  ">
                                    
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/shopback-bags-25m-in-latest-funding-round/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={shopback} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/shopback-bags-25m-in-latest-funding-round/" className="otw-link-single">ShopBack bags $25m in latest funding round</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        Singapore’s&nbsp;ShopBack&nbsp;has just closed a funding round worth US$25 million, it announced today. It has raised a total of US$40 million in venture funding to date.<br />
                                        <br />
                                        Fourteen investors participated in the round, which was led by Japanese credit card issuer and Mizuho Financial Group affiliate Credit Saison.
                                        <br />
                                        <br />
                                        Among new backers to come on
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/shopback-bags-25m-in-latest-funding-round/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
                                  <h3 className="otw_blog_manager-timeline-title">Jan 2017</h3>
                                  <article className="otw_blog_manager-blog-full  ">
                                    
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={boomwatch} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/" className="otw-link-single">This Swedish crowdfunding hit is taking on Daniel Wellington – by letting you design a personalized luxury watch</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        (Jan 2017: http://nordic.businessinsider.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington---by-letting-you-design-your-own-scandinavian-made-luxury-watch-2017-1/)
                                        <br />
                                        <br />
                                        Daniel Wellington, the Swedish watch empire headed by&nbsp;Filip Tysander, defined the watch trends for millenials in the post 2010-era.
                                        <br />
                                        <br />
                                        A social media-savvy marketing strategy, combined with an accurate reading of prevailing trends and a seamless supply chain made the company's revenues explode from 0 to $100+ million within five
                                      </p>
                                    </div>
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <a href="/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/" className="otw_blog_manager-blog-continue-reading">
                                      Continue reading →</a>
                                    </div>
                                  </article>
                                </div>
                                <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
                                  <article className="otw_blog_manager-blog-full  ">
                                    
                                    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                      <a href="/singapore-mc-payment-acquires-controlling-stake-in-alipay-licensed-genesis/" className="otw-media-container otw-link-single" data-width="460">
                                        <img src={mcpayment_one} alt="" title="" />
                                        <span className="theHoverBorder"></span>
                                      </a>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                      <h3 className="otw_blog_manager-blog-title">
                                        <a href="/singapore-mc-payment-acquires-controlling-stake-in-alipay-licensed-genesis/" className="otw-link-single">Singapore: MC Payment acquires controlling stake in Alipay-licensed Genesis</a>
                                      </h3>
                                    </div>
                                    
                                    
                                    <div className="otw_blog_manager-blog-content">
                                      <p>
                                        Singapore-based fintech firm MC Payment has taken a controlling stake in Genesis Payment Solutions (Genesis), which is licensed by Alipay to acquire merchants on its behalf. Financial terms of the acquisition was undisclosed. The deal gives MC Payment direct access to Genesis’ merchant acquiring license with Alipay as well as
                                      </p>
                                    </div>
                                  
                                  <div className="otw_blog_manager-blog-content">
                                    <a href="/singapore-mc-payment-acquires-controlling-stake-in-alipay-licensed-genesis/" className="otw_blog_manager-blog-continue-reading">
                                    Continue reading →</a>
                                  </div>
                                </article>
                              </div>
                              <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
                                <h3 className="otw_blog_manager-timeline-title">Nov 2016</h3>
                                <article className="otw_blog_manager-blog-full  ">
                                  
                                  <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                    <a href="/guavapass-gets-us5m-series-a-led-by-vickers-venture-partners/" className="otw-media-container otw-link-single" data-width="460">
                                      <img src={guavapass} alt="" title="" />
                                      <span className="theHoverBorder"></span>
                                    </a>
                                  </div>
                                  
                                  
                                  <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                    <h3 className="otw_blog_manager-blog-title">
                                      <a href="/guavapass-gets-us5m-series-a-led-by-vickers-venture-partners/" className="otw-link-single">GuavaPass gets US$5M Series A led by Vickers Venture Partners</a>
                                    </h3>
                                  </div>
                                  
                                  
                                  <div className="otw_blog_manager-blog-content">
                                    <p>
                                      (Nov 2016: https://e27.co/singapores-guavapass-bulks-us5-million-series-led-vickers-venture-partners-20161107/)
                                      <br />
                                      <br />
                                      GuavaPass, the Singaporean startup that allows people to sign-up for&nbsp;individual fitness classNamees across multiple gyms, has announced today it raised a US$5 million Series A funding round led by Vickers Venture Partners.
                                      <br />
                                      <br />
                                      The plan is to use the money to aggressively expand to other markets and focus on operational
                                    </p>
                                  </div>
                                  
                                  <div className="otw_blog_manager-blog-content">
                                    <a href="/guavapass-gets-us5m-series-a-led-by-vickers-venture-partners/" className="otw_blog_manager-blog-continue-reading">
                                    Continue reading →</a>
                                  </div>
                                </article>
                              </div>
                              <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
                                <article className="otw_blog_manager-blog-full  ">
                                  
                                  <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
                                    <a href="/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="otw-media-container otw-link-single" data-width="460">
                                      <img src={mcpayment_two} alt="" title="" />
                                      <span className="theHoverBorder"></span>
                                    </a>
                                  </div>
                                  
                                  
                                  <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
                                    <h3 className="otw_blog_manager-blog-title">
                                      <a href="/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="otw-link-single">Thailand's 2W Group leads S$5M investment into MC Payment to finance expansion</a>
                                    </h3>
                                  </div>
                                  
                                  
                                  <div className="otw_blog_manager-blog-content">
                                    <p>
                                      (Nov 2016:https://e27.co/thailands-2w-group-invests-us5m-into-singapores-mc-payment-to-help-it-expand-into-country-20161111/)
                                      <br />
                                      <br />
                                      MC Payment, an omni-channel payments solution based in Singapore, announced today it has raised a S$5 million strategic investment round from a Thailand investment firm named 2W Group.
                                      <br />
                                      <br />
                                      The 2W Group Managing Director is&nbsp;Schwin&nbsp;Chiaravanont, a member of the Chearavanont family (whose ownership of the Charoen Pokhphand Group makes them one
                                    </p>
                                  </div>
                                  
                                  <div className="otw_blog_manager-blog-content">
                                    <a href="/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="otw_blog_manager-blog-continue-reading">
                                    Continue reading →</a>
                                  </div>
                                </article>
                              </div>
                              <div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
  <h3 className="otw_blog_manager-timeline-title">Sep 2016</h3>
  <article className="otw_blog_manager-blog-full  ">
  
    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
      <a href="/goldfields-money-offers-60m-merger-proposal/" className="otw-media-container otw-link-single" data-width="460">
        <img src={asx} alt="" title="" />
        <span className="theHoverBorder"></span>
      </a>
    </div>
    
    
    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
      <h3 className="otw_blog_manager-blog-title">
        <a href="/goldfields-money-offers-60m-merger-proposal/" className="otw-link-single">Goldfields Money offers $60m merger proposal</a>
      </h3>
    </div>
    
    
    <div className="otw_blog_manager-blog-content">
      <p>
        (Friday, 24 November 2017 8:52AM - https://thewest.com.au/business/goldfields-money-offers-60m-merger-proposal-ng-b88670038z )
        <br />
        <br />
        Goldfields Money has offered up a $60 million merger proposal with one of the country’s fastest-growing mortgage wholesalers as the alternative to Firstmac’s hostile cash takeover bid.
        <br />
        Under a preliminary agreement finalised late yesterday, Sydney-based Finsure would emerge with 63 per cent of the
      </p>
    </div>
    
    <div className="otw_blog_manager-blog-content">
      <a href="/goldfields-money-offers-60m-merger-proposal/" className="otw_blog_manager-blog-continue-reading">
        Continue reading →
      </a>
    </div>
  </article>
</div>
<div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item even">
  <article className="otw_blog_manager-blog-full  ">
  
    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
      <a href="/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="otw-media-container otw-link-single" data-width="460">
        <img src={asx} alt="" title="" />
        <span className="theHoverBorder"></span>
      </a>
    </div>
    
    
    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
      <h3 className="otw_blog_manager-blog-title">
        <a href="/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="otw-link-single">Singapore crowdfunding platform CoAssets lists on ASX</a>
      </h3>
    </div>
    
    
    <div className="otw_blog_manager-blog-content">
      <p>
        (MON, SEP 05, 2016 - 10:25 AM - http://www.businesstimes.com.sg/companies-markets/singapore-crowdfunding-platform-coassets-lists-on-asx )
        <br />
        <br />
        SINGAPORE-BASED real estate and debt crowdfunding platform CoAssets on Monday announced that it has listed on the Australian Securities Exchange (ASX), after raising AS$6.55 million (S$6.72 million) in its initial public offering (IPO) at an issue price of A$0.40 per share.
        <br />
        <br />
      </p>
    </div>
    
    <div className="otw_blog_manager-blog-content">
      <a href="/singapore-crowdfunding-platform-coassets-lists-on-asx/" className="otw_blog_manager-blog-continue-reading">
      Continue reading →</a>
    </div>
  </article>
</div>
<div className="otw-twelve otw-columns otw_blog_manager-blog-timeline-item odd">
  <h3 className="otw_blog_manager-timeline-title">Nov 2017</h3>
  <article className="otw_blog_manager-blog-full  ">
  
    <div className="otw_blog_manager-blog-media-wrapper otw_blog_manager-format-image hover-style-1-full">
      <a href="/sgx-listed-artivision-to-buy-fintech-firm-mc-payment-for-upwards-of-59m/" className="otw-media-container otw-link-single" data-width="460">
        <img src={artivision} alt="" title="" />
        <span className="theHoverBorder"></span>
      </a>
    </div>
    
    
    <div className="otw_blog_manager-blog-title-wrapper otw_blog_manager-format-image">
      <h3 className="otw_blog_manager-blog-title">
        <a href="/sgx-listed-artivision-to-buy-fintech-firm-mc-payment-for-upwards-of-59m/" className="otw-link-single">SGX-listed Artivision to buy fintech firm MC Payment for upwards of $59m</a>
      </h3>
    </div>
    
    
    <div className="otw_blog_manager-blog-content">
      <p>
        Singapore-listed Artivision Technologies has agreed to buy local fintech firm MC Payment for a minimum of S$80 million ($59 million), the companies announced, in what will be amongst the largest exits amongst startups in this space in the city-state.
        <br />
        <br />
        Following the announcement, the Artivision stock surged on the SGX on Wednesday.
      </p>
    </div>
    
    <div className="otw_blog_manager-blog-content">
      <a href="/sgx-listed-artivision-to-buy-fintech-firm-mc-payment-for-upwards-of-59m/" className="otw_blog_manager-blog-continue-reading">
      Continue reading →</a>
    </div>
  </article>
</div>
                            </div>
                            <div className="otw_blog_manager-pagination hide">
                              <a href="https://33-capital.com/wp-admin/admin-ajax.php?action=get_posts&amp;post_id=1&amp;nonce=41134fb0dd&amp;page=2">2</a>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="social-share">
                  <div className="row">
                    <div className="col-xs-6 share-text">Share</div>
                    <div className="col-xs-6 share-button">
                      <div className="btn-group">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/news/" className="btn btn-default" target="_blank" rel="noopener noreferrer">
                          <i className="icon-facebook"></i>
                        </a>
                        <a href="https://plus.google.com/share?url=https://33-capital.com/news/" className="btn btn-default" target="_blank" rel="noopener noreferrer">
                          <i className="icon-gplus"></i>
                        </a>
                        <a href="https://twitter.com/intent/tweet?text=News&amp;url=https://33-capital.com/news/" className="btn btn-default" target="_blank" rel="noopener noreferrer">
                          <i className="icon-twitter"></i>
                        </a>
                        <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/news/&amp;title=News&amp;=&amp;source=https://33-capital.com/news/" className="btn btn-default" target="_blank" rel="noopener noreferrer">
                          <i className="icon-linkedin"></i>
                        </a>
                        <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/news/&amp;description=&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer">
                          <i className="icon-pinterest"></i>
                        </a>
                      </div>                  
                    </div>
                  </div>
                </div>  
                <hr></hr>
                <div className="comment-count">
                  No Comments
                </div>            
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/news.js